import script from "./system-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./system-settings.vue?vue&type=script&setup=true&lang=js"

import "./system-settings.vue?vue&type=style&index=0&id=6bb3b1fe&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb3b1fe"]])

export default __exports__